function initFiltrosURL() {

    const params = new URLSearchParams(window.location.search);
    const tipo = params.get("tipo");

    const filtroTipo = document.getElementById("filtro-tipo-select");

    if (!filtroTipo) return;

    if (tipo) {
        filtroTipo.value = tipo;
        filtroTipo.dispatchEvent(new Event("change"));
    }
}

// Carga normal del sitio
document.addEventListener("DOMContentLoaded", initFiltrosURL);

// Shopify Theme Editor (CLAVE)
document.addEventListener("shopify:section:load", initFiltrosURL);